export default (Vue) => {
  // ajax配置
  Vue.prototype.$hasPerm = (permission) => {
    const permissions = localStorage.getItem('permissions');
    permission = `"permissionCode":"${permission}"`;
    if (!permissions) {
      return false;
    }
    return permissions.indexOf(permission) > -1;
  };

  Vue.prototype.$account = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account);
  };

  Vue.prototype.$partA = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account).companyType === 'party_a';
  };

  Vue.prototype.$partB = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account).companyType === 'party_b';
  };
  Vue.prototype.$collectible = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return (JSON.parse(account).businessType === 'collection' || JSON.parse(account).businessType === 'collection-two');
  };

  Vue.prototype.$getInternationalVersionFlag = () => {
    const internationalVersionFlag = localStorage.getItem('internationalVersionFlag');
    if (!internationalVersionFlag) {
      return '0';
    }
    return internationalVersionFlag;
  };

  Vue.prototype.$getLanguageSelectOptions = () => {
    const languageSelectOptions = localStorage.getItem('languageSelectOptions');
    if (!languageSelectOptions) {
      return [];
    }
    return JSON.parse(languageSelectOptions);
  };

  Vue.prototype.$getLanguageSelect = () => {
    const languageSelect = localStorage.getItem('languageSelect');
    if (languageSelect) {
      return languageSelect;
    }
    const account = localStorage.getItem('account');
    if (account) {
      const accountObj = JSON.parse(account);
      localStorage.setItem('languageSelect', accountObj.workLanguage);
      return accountObj.workLanguage || '0';
    }
    return '0';
  };

  Vue.prototype.$setLanguageSelect = (languageCode) => {
    localStorage.setItem('languageSelect', languageCode);
    Vue.prototype.$bus.$emit('languageSelectChanged', languageCode);
  };

  Vue.prototype.$getWorkLanguage = () => {
    const account = localStorage.getItem('account');
    if (account) {
      const accountObj = JSON.parse(account);
      return accountObj.workLanguage || '0';
    }
    return '0';
  };
};



// WEBPACK FOOTER //
// ./src/utils/auth.js